export default {"src":"/evde-internet/_next/static/media/mail.d004f5a2.svg","height":32,"width":32};